import { I18n } from 'aws-amplify';
import PropTypes from 'prop-types';
import { TextField, MenuItem } from '@material-ui/core';

MultiAuthSetting.propTypes = {
    usingMultiAuth: PropTypes.any,
    onChangeUsingMultiAuth: PropTypes.any
};

export default function MultiAuthSetting({ usingMultiAuth, onChangeUsingMultiAuth }) {
    return (
        <div className="org-profile-wrap-footer">
            <div style={{ display: 'flex', gap: 16 }}>
                <div className="org-profile-wrap-title" style={{ marginBottom: 0 }}>
                    {I18n.get('LABEL-FUNCTION-MULTI-AUTH')}
                </div>
                <div className="switch-check setting-ai-function">
                    <input
                        name="multiAuth"
                        id="setting-multiAuth-switch-id"
                        type="checkbox"
                        checked={usingMultiAuth}
                        onChange={onChangeUsingMultiAuth}
                    />
                    <label htmlFor="setting-multiAuth-switch-id" style={{ color: 'transparent' }}>
                        .
                    </label>
                </div>
            </div>
            {usingMultiAuth && (
                <div className="org-profile-field" style={{ paddingBottom: 0, paddingTop: 16 }}>
                    <div className="title-name">{I18n.get('AUTH-METHOD')}</div>
                    <TextField
                        className="form-control form-control--wrap form-control--hg40"
                        select
                        disabled
                        variant="outlined"
                        value={I18n.get('APPLICATION-AUTH')}
                        defaultValue={I18n.get('APPLICATION-AUTH')}
                    >
                        {[I18n.get('APPLICATION-AUTH')].map(item => {
                            return (
                                <MenuItem key={item} value={item}>
                                    {item}
                                </MenuItem>
                            );
                        })}
                    </TextField>
                </div>
            )}
        </div>
    );
}
